import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { DeployPriorityComponent } from './deploy-priority.component';
import { CustomerSensitivityScoresComponent } from './customer-sensitivity-scores.component';
import { DeploySensitivityWeightingsComponent } from './deploy-sensitivity-weightings.component';
import { JobDeployPriorityGradingsComponent } from './deploy-priority-gradings.component';
import { DeployPriorityGradingRulesComponent } from './deploy-priority-grading-rules.component';
import { ColorPickerModule } from 'primeng/colorpicker';
import { TableModule } from 'primeng/table';

const routes: Routes = [
  { path: '', component: DeployPriorityComponent, data: { title: 'Job Deployment Priority' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeployPriorityRoutingModule {}

@NgModule({
  imports: [
    DeployPriorityRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    ColorPickerModule,
    TableModule,
  ],
  declarations: [
    DeployPriorityComponent,
    CustomerSensitivityScoresComponent,
    DeploySensitivityWeightingsComponent,
    JobDeployPriorityGradingsComponent,
    DeployPriorityGradingRulesComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DeployPriorityModule {}
